import React from 'react'
import {
  Wrapper,
  LogoWrapper,
  ContentWrapper,
  LeftContentSection,
  Heading
} from './StoreErrorPageStyledComponents'
import Logo from '../../components/layout/Logo/Logo'
import { FormattedMessage } from 'react-intl'

interface Props {
  response: string
}

function MenuNotFound({response}: Props) {
  return (
    <Wrapper>
      <LogoWrapper>
        <Logo storeSource="ZEROTOUCH" />
      </LogoWrapper>
      <ContentWrapper>
        <LeftContentSection>
          <div>
            <Heading>
              <FormattedMessage id='storeErrorPage.notAvailable' />
            </Heading>
            <span>
              {response}
            </span>
          </div>
        </LeftContentSection>
      </ContentWrapper>
      <div />
      <div />
    </Wrapper>
  )
}

MenuNotFound.displayName = 'MenuNotFound'

export default MenuNotFound